import React, { useState, useEffect } from 'react';
import { db } from '../../../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { message, Spin, Form, Input, Button, DatePicker } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import './CMEPaymentPage.css'; // Your custom styles
import QRimg from '../../../assets/qr-img.jpg';

function CMEPaymentPage() {
  const { state } = useLocation();
  const { requestId } = state;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const collectionName = requestId.startsWith('ADV')
          ? 'advertisementRequests'
          : 'CME-requests';
        const docRef = doc(db, collectionName, requestId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          message.error('Request data not found.');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        message.error('Failed to retrieve request data.');
      } finally {
        setLoading(false);
      }
    };

    if (requestId) fetchAmount();
  }, [requestId]);

  const handleSubmitPayment = async (values) => {
    try {
      const collectionName = requestId.startsWith('ADV')
        ? 'advertisementRequests'
        : 'CME-requests';
      const requestDocRef = doc(db, collectionName, requestId);
      await updateDoc(requestDocRef, {
        transactionId: values.transactionId,
        paymentDateTime: values.paymentDateTime.format('YYYY-MM-DD HH:mm:ss'),
        bankName: values.bankName,
        payerName: values.payerName,
        status: 'Paid',
      });

      message.success('Payment submitted successfully!');
      navigate('/PaymentSuccess');
    } catch (error) {
      console.error('Error submitting payment:', error);
      message.error('Failed to submit payment.');
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    );
  }

  if (data?.status === 'Paid') {
    navigate(`/Request/${requestId}`);
  }

  return (
    <div className="payment-page-container">
      <div className="payment-header">
        <h3>Payment Options</h3>
        <h4>Amount: {data?.paymentAmount ? `₹${data.paymentAmount}` : 'N/A'}</h4>
        <p>Please complete your payment using the QR Code or Bank Details provided.</p>

        <div className="payment-methods">
          <div className="qr-code-container">
            <img src={QRimg} alt="QR Code" draggable="false" oncontextmenu="return false "/>
            <p>Scan the QR Code</p>
          </div>
          {/* <div className="bank-details">
            <h3>Bank Account Details</h3>
            <p>Bank Name: XYZ Bank</p>
            <p>Account Number: 1234567890</p>
            <p>IFSC Code: XYZB0001234</p>
          </div> */}
        </div>
      </div>

      <Form layout="vertical" onFinish={handleSubmitPayment} className="payment-form">
        <Form.Item
          label="Transaction ID/Reference Number"
          name="transactionId"
          rules={[{ required: true, message: 'Please enter the Transaction ID' }]}
        >
          <Input placeholder="Enter Transaction ID" size="large" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Payment Date & Time"
          name="paymentDateTime"
          rules={[{ required: true, message: 'Please select the Payment Date & Time' }]}
        >
          <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" size="large" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Bank Name"
          name="bankName"
          rules={[{ required: true, message: 'Please enter the Bank Name' }]}
        >
          <Input  placeholder="Enter Amount Paid" size="large" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Payer's Name" name="payerName">
          <Input placeholder="Enter Payer's Name (optional)" size="large" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            Submit Payment
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default CMEPaymentPage;
